<template>
  <b-badge
    v-if="data.value"
    :style="`background-color:${backgroundColor};color:${color}`"
    pill
    :variant="!backgroundColor ? 'light-secondary' : '' "
  >
    {{ data.value }}
  </b-badge>
  <span v-else>
    {{ data.value }}
  </span>

</template>

<script>
import { BBadge } from 'bootstrap-vue'
import { getTextColor } from '@/utils/utils'
import BaseDisplayType from './Base.vue'

export default {
  name: 'PicklistDisplayType',
  components: {
    BBadge,
  },
  extends: BaseDisplayType,
  computed: {
    color() {
      return getTextColor(this.backgroundColor)
    },
    backgroundColor() {
      const { info, data } = this
      if (info.colors[data.value]) {
        return info.colors[data.value]
      }
      const find = info.picklistValues.find(item => item.value === data.value)
      if (find && info.colors[find.label]) {
        return info.colors[find.label]
      }
      return null
    },
  },
}
</script>

<style scoped>

</style>
